module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-8-ed0b92a86218df0dce47d4d9c81fbca1.jpg";